import "./Research.scss";
import { useTheme } from "../../context/ThemeContext";
import { useEffect } from "react";
import ResearchArticle from "../../components/research/ResearchArticle/ResearchArticle";
import redSquare from "../../assets/icons/type-squares/red-square.svg";
import blueSquare from "../../assets/icons/type-squares/blue-square.svg";

function Research({ CLOUDFRONT_URL }) {
  const { setThemeByName } = useTheme();
  useEffect(() => {
    setThemeByName("theme2");

    return () => {
      setThemeByName("default");
    };
  }, [setThemeByName]);

  const researchArticles = [
    {
      title:
        "AGI for the Earth: the path, possibilities and how to evaluate intelligence of models that work with Earth Observation Data",
      date: "August 8th, 2025",
      type: "ACADEMIC",
      square: redSquare,
      image: `${CLOUDFRONT_URL}/blog-images/placeholder/HUM-AI-Logo-Grid-Graphic-Bitmap-Grey.png`,
      preview:
        "Artificial General Intelligence (AGI) is closer than ever to becoming a reality, sparking widespread enthusiasm "
        + "in the research community to collect and work with various modalities, including text, image, video, and audio. "
        + "Despite recent efforts, satellite spectral imagery, as an additional modality, has yet to receive the attention it deserves. "
        + "This area presents unique challenges, but also holds great promise in advancing the capabilities of AGI in understanding the natural world.",
      link: "/research/agi-for-the-earth"
    },
    {
      title:
        "SeeFar: A satellite agnostic multi-resolution dataset for geospatial foundation models",
      date: "June 10th, 2024",
      type: "ACADEMIC",
      square: blueSquare,
      image: `${CLOUDFRONT_URL}/research-images/seefar/seefar_preview.png`,
      preview:
        "SeeFar is an evolving collection of multi-resolution satellite images from public and commercial satellites. We specifically curated "
        + "this dataset for training geospatial foundation models, unconstrained by satellite type. In recent years, advances in technology have made "
        + "satellite imagery more accessible than ever. More earth-observing satellites have been launched in the last five years than in the previous fifty. "
        + "Modern commercial satellites now offer up to 100 times the spatial resolution of public access satellites. However, the high cost and limited "
        + "historical availability of commercial satellite imagery is a barrier to the training of foundational models, impacting what images can be used "
        + "during inference. The SeeFar dataset represents a step towards training models that are satellite-agnostic by combining multi-resolution commercial "
        + "and public access pre-processed images. This will enable users to utilize historical data alongside higher-resolution, more expensive satellite "
        + "imagery, offering greater flexibility during inference.",
      link: "/research/seefar"
    },
  ];

  return (
    <>
      <div className="research">
        <div className="research__container">
          <div className="research__title-section">
            <div className="research__title">Hum with us</div>
          </div>
          <div className="research__articles">
            {researchArticles.map((article, index) => (
              <ResearchArticle
                key={index}
                title={article.title}
                date={article.date}
                type={article.type}
                image={article.image}
                square={article.square}
                preview={article.preview}
                link={article.link}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Research;
